'use strict';exports.__esModule = true;var checkIsraelCardholderId = function checkIsraelCardholderId() {var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (id === '' || id === null || id.toString().length > 9) {
    return false;
  }

  var idString = id.toString();

  while (idString.length < 9) {
    idString = '0' + idString;
  }

  var parsedId = idString.split('');

  var sumValue = parsedId.
  map(function (item, idx) {
    var multiplier = idx % 2 === 0 ? 1 : 2;
    return item * multiplier;
  }).
  reduce(function (acc, value) {
    acc += value > 9 ? value % 10 + 1 : value;
    return acc;
  }, 0);

  var result = sumValue % 10;

  return !(isNaN(result) || result > 0);
};exports.default =

checkIsraelCardholderId;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/checkIsraelCardholderId.js
// module id = 3126
// module chunks = 0